
export default function BasicSpecs() {
  const specs = [
    { label: 'カード名', value: '地域密着型クレジットカード' },
    { label: '発行会社', value: '三菱UFJニコス株式会社' },
    { label: '年会費（本会員）', value: '初年度無料、次年度より1,375円（税込）※条件達成で無料' },
    { label: '年会費（家族会員）', value: '初年度無料、次年度より440円（税込）※条件達成で無料' },
    { label: '年会費無料条件', value: '①年間12万円以上利用 ②電気料金支払い登録 ③携帯電話料金支払い登録（いずれか1つ）' },
    { label: 'ポイント還元率', value: '0.5%（1,000円で1ポイント）※提携店舗で+2%' },
    { label: '国際ブランド', value: 'Visa / Mastercard' },
    { label: 'カード種別', value: '一般カード' },
    { label: '申込条件', value: '18歳以上でご本人または配偶者に安定した収入のある方、または18歳以上の学生（高校生除く）' },
    { label: '必須条件', value: '提携金融機関口座の保有が必要' },
    { label: 'ポイント名', value: 'カード独自ポイントプログラム' },
    { label: 'ポイント交換', value: 'キャッシュバック、ギフトカード、商品交換など' },
    { label: '海外旅行傷害保険', value: '最高2,000万円（利用付帯）' },
    { label: '直売所割引', value: 'ご請求時にいつでも5%割引（全国1,100店舗以上）' },
    { label: '給油所割引', value: '1Lにつき2円割引（全国2,000店舗以上）' },
    { label: '提携店舗還元', value: '提携スーパー・購買店舗・通販サイト等で+2%ポイント還元' },
    { label: '携帯電話特典', value: '携帯料金支払いで1,000円相当ポイント（250ポイント）' },
    { label: 'ETCカード', value: '発行可能' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-8 text-center">
          地域密着型クレジットカードの基本スペック
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-[#F0FFF4]' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-bold text-gray-700 border-b border-gray-200 w-1/3">
                    {spec.label}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
